import { useEffect, useState } from "react";
import { Box, Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputsYorN from "../ProfilesComp/InputsYorN";
import InputBasic from "../ProfilesComp/InputsBasic";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useDispatch, useSelector } from "react-redux";
import { updateSectionMentalHealth } from "../../../store/Profiles/profilesSlice";

const StepMentalHealthCuest = ({ onBack, onNext }) => {
    const storedData = useSelector(state => state.profiles.MentalHealth);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        grooming: "",
        oriented: "",
        motorCoordination: "",
        thoughtContent: "",
        thoughtContentDetails: "",
        memory: "",
        memoryDetails: "",
        judgment: "",
        insight: "",
        underInfluence: "",
        hasMentalHealthIssues: "",
        mentalHealthIssuesDetails: "",
        significantMentalHealthEvent: "",
        significantMentalHealthEventExplain: "",
        lifeChanges: "",
        lifeChangesDetails: "",
        wantsHelp: "",
        interestedInTherapy: "",
        pastTherapy: "",
        pastTherapyDetails: "",
        pastDiagnosis: "",
        currentTreatment: "",
        currentTreatmentDetails: "",
        currentDiagnosis: ""
    });

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            ...storedData
        }));
    }, [storedData]);

    const handleChange = (key, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [key]: value
        }));
    };

    const handleNextStep = async () => {
        await handleSaveData(); // 🔹 Espera que termine antes de seguir
        onNext();
    };

    const handleSaveData = async () => {
      dispatch(updateSectionMentalHealth({ section: "MentalHealth", data: { MentalHealth:formData } }));
    }

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {t("Profiles.MentalHealth.MentalHealth")}
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Isclient’sgrooming")} 
                    value={formData.grooming} onChange={(value) => handleChange("grooming", value)} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Isclientoriented")} 
                    value={formData.oriented} onChange={(value) => handleChange("oriented", value)} />
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
            <FormLabel component="legend">{t("Profiles.MentalHealth.Motorcoordination")}</FormLabel>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <FormControl component="fieldset" >
                    <RadioGroup row value={formData.motorCoordination} onChange={(e) => handleChange("motorCoordination", e.target.value)}>
                        <FormControlLabel value="good" control={<Radio />} label={t("Profiles.Dental.good")} />
                        <FormControlLabel value="fair" control={<Radio />} label={t("Profiles.Dental.fair")} />
                        <FormControlLabel value="poor" control={<Radio />} label={t("Profiles.Dental.poor")} />
                    </RadioGroup>
                </FormControl>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <FormLabel component="legend">{t("Profiles.MentalHealth.Thoughtcontent")}</FormLabel>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <FormControl component="fieldset">
                    <RadioGroup row value={formData.thoughtContent} onChange={(e) => handleChange("thoughtContent", e.target.value)}>
                        <FormControlLabel value="clear" control={<Radio />} label={t("Profiles.MentalHealth.Clear")} />
                        <FormControlLabel value="impaired" control={<Radio />} label={t("Profiles.MentalHealth.Impaired")} />
                    </RadioGroup>
                </FormControl>
                {formData.thoughtContent === "impaired" && (
                    <InputBasic Translation="Profiles.MentalHealth.Ifimpaired" value={formData.thoughtContentDetails} 
                    onChange={(e) => handleChange("thoughtContentDetails", e.target.value)} />
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <FormLabel component="legend">{t("Profiles.MentalHealth.Memory")}</FormLabel>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <FormControl component="fieldset">
                    <RadioGroup row value={formData.memory} onChange={(e) => handleChange("memory", e.target.value)}>
                        <FormControlLabel value="impaired" control={<Radio />} label={t("Profiles.MentalHealth.Impaired")} />
                        <FormControlLabel value="unimpaired" control={<Radio />} label={t("Profiles.MentalHealth.Unimpaired")} />
                    </RadioGroup>
                </FormControl>
                {formData.memory === "impaired" && (
                    <InputBasic Translation="Profiles.MentalHealth.Ifimpaired" value={formData.memoryDetails} 
                    onChange={(e) => handleChange("memoryDetails", e.target.value)} />
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <FormLabel component="legend">{t("Profiles.MentalHealth.Judgment")}</FormLabel>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <FormControl component="fieldset">
                    <RadioGroup row value={formData.judgment} onChange={(e) => handleChange("judgment", e.target.value)}>
                        <FormControlLabel value="impaired" control={<Radio />} label={t("Profiles.MentalHealth.Impaired")} />
                        <FormControlLabel value="unimpaired" control={<Radio />} label={t("Profiles.MentalHealth.Unimpaired")} />
                    </RadioGroup>
                </FormControl>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <FormLabel component="legend">{t("Profiles.MentalHealth.Insight")}</FormLabel>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <FormControl component="fieldset">
                    <RadioGroup row value={formData.insight} onChange={(e) => handleChange("insight", e.target.value)}>
                        <FormControlLabel value="impaired" control={<Radio />} label={t("Profiles.MentalHealth.Impaired")} />
                        <FormControlLabel value="somewhat" control={<Radio />} label={t("Profiles.MentalHealth.Somewhat")} />
                        <FormControlLabel value="intact" control={<Radio />} label={t("Profiles.MentalHealth.Intact")} />
                    </RadioGroup>
                </FormControl>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Appearstobeunder")} 
                value={formData.underInfluence} onChange={(value) => handleChange("underInfluence", value)} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Doyouhave")} 
                    value={formData.hasMentalHealthIssues} onChange={(value) => handleChange("hasMentalHealthIssues", value)} />
                {formData.hasMentalHealthIssues === "yes" && (
                    <InputBasic Translation="Profiles.MentalHealth.Ifyes,explain" 
                    value={formData.mentalHealthIssuesDetails} onChange={(e) => handleChange("mentalHealthIssuesDetails", e.target.value)} />
                )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Haveyouhadasignificant")} 
                    value={formData.significantMentalHealthEvent} onChange={(value) => handleChange("significantMentalHealthEvent", value)} />
                {formData.significantMentalHealthEvent === "yes" && (
                    <InputBasic Translation="Profiles.MentalHealth.Ifyes,explain" 
                    value={formData.significantMentalHealthEventExplain} onChange={(e) => handleChange("significantMentalHealthEventExplain", e.target.value)} />
                )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Arethereanylife")} 
                    value={formData.lifeChanges} onChange={(value) => handleChange("lifeChanges", value)} />
                {formData.lifeChanges === "yes" && (
                    <InputBasic Translation="Profiles.MentalHealth.Pleasedescribe" 
                    value={formData.lifeChangesDetails} onChange={(e) => handleChange("lifeChangesDetails", e.target.value)} />
                )}
            </Box>

            {/* Botones */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
                <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepMentalHealthCuest;
